export default "__VITE_ASSET__z$C$$kNC__"